import script from "./GreenifiedCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./GreenifiedCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./GreenifiedCheckbox.vue?vue&type=style&index=0&id=7b612c14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b612c14"]])

export default __exports__